import React, { useEffect, useState } from 'react';
import { Link, withRouter } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faFacebookSquare, faInstagram } from '@fortawesome/free-brands-svg-icons';
import { faCalendarAlt, faClock, faUsers, faChevronDown } from '@fortawesome/free-solid-svg-icons';
import { DatePicker, TimePicker } from '@material-ui/pickers';
import Select from 'react-select';
import moment from 'moment';
import Navbar from '../Navbar';
import logo from '../../images/Limitless-BNG_WordmarkLogo.png';
import './index.scss';

const HOURS = [
  ['Monday',    '11:30AM - 2AM'],
  ['Tuesday',   '11:30AM - 2AM'],
  ['Wednesday', '11:30AM - 2AM'],
  ['Thursday',  '11:30AM - 2AM'],
  ['Friday',    '11:30AM - 2AM'],
  ['Saturday',  '11:30AM - 2AM'],
  ['Sunday',    '11:30AM - 12AM'],
];

const GUEST_OPTIONS = [
  { label: '1', value: '1' },
  { label: '2', value: '2' },
  { label: '3', value: '3' },
  { label: '4', value: '4' },
  { label: '5', value: '5' },
  { label: '6', value: '6' },
  { label: '7', value: '7' },
  { label: '8+', value: '8+' },
];

const selectStyles = {
  control: base => ({ ...base, border: 'none', boxShadow: 'none', backgroundColor: 'transparent', minHeight: 'auto', cursor: 'pointer' }),
  valueContainer: base => ({ ...base, padding: 0 }),
  singleValue: base => ({ ...base, fontWeight: 700, fontSize: '16px', color: '#000' }),
  indicatorSeparator: () => ({ display: 'none' }),
  dropdownIndicator: base => ({ ...base, padding: 0, color: '#000' }),
  menu: base => ({ ...base, zIndex: 10 }),
};

const Reservation = ({ history }) => {
  const [date, setDate] = useState(moment().add(1, 'day'));
  const [time, setTime] = useState(moment().hour(19).minute(0));
  const [guests, setGuests] = useState(GUEST_OPTIONS[1]);

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const handleReserveTable = () => {
    // moment instances hold function references internally and can't be
    // structured-cloned by history.pushState, so serialize to ISO strings
    history.push('/reservation/details', { date: date.toISOString(), time: time.toISOString(), guests });
  };

  return (
    <div className="reservation">
      <Navbar />

      <div className="reservation-body">
        <Link to="/landing2" className="back-btn">&#8592;</Link>

        <h1 className="reservation-title">Make a Reservation</h1>
        <p className="reservation-subtitle">Limitless Bar &amp; Grill</p>
        <p className="reservation-address">1450 Centre Street, Unit 3<br />Thornhill, ON</p>

        <div className="reservation-card">
          <div className="card-row">
            <FontAwesomeIcon icon={faCalendarAlt} className="row-icon" />
            <DatePicker
              value={date}
              onChange={setDate}
              minDate={moment()}
              labelFunc={d => (d ? d.format('MMMM D, YYYY') : '')}
              InputProps={{ disableUnderline: true }}
              className="row-input"
            />
            <FontAwesomeIcon icon={faChevronDown} className="row-chevron" />
          </div>
          <div className="card-divider" />
          <div className="card-row">
            <FontAwesomeIcon icon={faClock} className="row-icon" />
            <TimePicker
              value={time}
              onChange={setTime}
              labelFunc={t => (t ? t.format('h:mm A') : '')}
              InputProps={{ disableUnderline: true }}
              className="row-input"
            />
            <FontAwesomeIcon icon={faChevronDown} className="row-chevron" />
          </div>
          <div className="card-divider" />
          <div className="card-row">
            <FontAwesomeIcon icon={faUsers} className="row-icon" />
            <Select
              className="row-input row-select"
              styles={selectStyles}
              options={GUEST_OPTIONS}
              value={guests}
              onChange={setGuests}
              isSearchable={false}
              formatOptionLabel={opt => `${opt.label} ${opt.value === '1' ? 'Person' : 'People'}`}
            />
          </div>

          <button className="reserve-table-btn" onClick={handleReserveTable}>
            Reserve Table
          </button>
        </div>
      </div>

      {/* Footer */}
      <footer className="footer" id="contact">
        <div className="footer-top">
          <div className="footer-col">
            <h3>Contact Us</h3>
            <p>1450 Centre St., Unit 3</p>
            <p>L4J 3N1, Thornhill, ON</p>
            <br />
            <p>T: (905) 597-5252</p>
            <p>E: limitlessbarandgrill@gmail.com</p>
          </div>
          <div className="footer-col">
            <h3>Store Hours</h3>
            {HOURS.map(([day, hrs]) => (
              <div className="hours-row" key={day}>
                <span>{day}</span>
                <span>{hrs}</span>
              </div>
            ))}
          </div>
          <div className="footer-col footer-logo-col">
            <img src={logo} alt="Limitless Bar & Grill" className="footer-logo" />
          </div>
        </div>
        <div className="footer-social">
          <a href="https://www.facebook.com/limitlessbng" target="_blank" rel="noreferrer">
            <FontAwesomeIcon icon={faFacebookSquare} size="2x" />
          </a>
          <a href="https://www.instagram.com/limitlessbng" target="_blank" rel="noreferrer">
            <FontAwesomeIcon icon={faInstagram} size="2x" />
          </a>
        </div>
      </footer>
    </div>
  );
};

export default withRouter(Reservation);
